export default api => ({
    personData: () => api.get('cabinet/person_data/'),
    getMessages: (data) => api.get('messages/', {params: data}),
    setMessageAsRead: (id) => api.put(`messages/${id}/`, {was_read: true}),
    setAllMessagesAsRead:() => api.post('messages/all/', {read: true}),
    getDocumentsForSign: (data) => api.get('profile/cabinet/sign_otp/',{params:data}),
    getDocumentsSignOtp: (data) => api.post('profile/cabinet/sign_otp/', data),
    confirmDocumentsSignOtp: (data) => api.post('profile/cabinet/sign_otp/confirm', data),
    getDocuments: (data) => api.get('profile/cabinet/sign_otp/all/', {params:data}),
    getBalances: ()=> api.get('cabinet/balance/'),
    updateBalances: ()=> api.get('cabinet/balance/refresh/'),
    getAccounts: () => api.get('cabinet/accounts/'),
    getDocumentTypes: () => api.get('cabinet/refs/documents/'),
    getRequests: (data) => api.get('cabinet/requests', {params: data}),
    requestDocument: (data) => api.post('cabinet/requests', data),
    getDoc: (data, callback) => api.get(data, {responseType: 'blob', onDownloadProgress: callback} ),
    sendMoneyConfirmation: (data, callback) => api.post('cabinet/money_confirmations/', data, {onUploadProgress: callback}),
    getMoneyConfirmations: (data) => api.get('cabinet/money_confirmations/', {params:data}),
    createCard: (id, data) => api.post(`cabinet/accounts/${id}/create_card/`, data),
    createAccount: (data) => api.post('cabinet/accounts/', data),
    setPayout: ({id, currency}) => api.post(`cabinet/accounts/${id}/payout/`, {currency}),
    confirmAccountActionOtp: ({code}, {id, currency, action}) => api.post(`cabinet/accounts/${id}/confirm/${action}/`, {code, currency}),
    deleteCard:({id, card_number}) => api.delete(`cabinet/accounts/${id}/card/${card_number}/`),
    deleteAccount:({id}) => api.delete(`cabinet/accounts/${id}`),
    resendAccountOtpCode: (action) => api.post('cabinet/accounts/resend_code/', {action}),
    getAccountOtp: (data) => api.get(`cabinet/accounts/${data.id}/send_code/`),
    confirmAccountOtp: (code, data) => api.post(`cabinet/accounts/${data.id}/confirm/`, code),
    getAccountCardOtp: (data) => api.get(`cabinet/accounts/${data.id}/send_code/${data.card_uuid}/`),
    confirmAccountCardOtp: (code, data) => api.post(`cabinet/accounts/${data.id}/confirm/${data.card_uuid}/`,code),
    markAllDocumentsAsRead: (data) => api.post('profile/cabinet/sign_otp/all/read/'),
    markDocumentsForSignAsRead: (data) => api.post('profile/cabinet/sign_otp/read/'),
})
